import { useState } from 'react';
import type { GiornoEvento } from '@eventi/tipi.ts';

/**
 * Il giorno scelto fra quelli del programma. Se il programma cambia e quel
 * giorno non c'e' piu', si torna al primo.
 */
export function useGiornoScelto(giorni: GiornoEvento[]): [string, (codice: string) => void] {
  const [scelto, setScelto] = useState<string | null>(null);
  const attivo = giorni.some((g) => g.codice === scelto) ? (scelto as string) : giorni[0]?.codice ?? '';
  return [attivo, setScelto];
}
